import { Component } from '@verndale/core';
import { BREAKPOINTS } from '../constants';
import Tabs from './tabs';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $tabsContainer: this.el._$('.quick-access__tabs'),
      $triggers: this.el._$$('.quick-access__trigger'),
      $panels: this.el._$$('[role="tabpanel"]'),
      $triggersContainer: this.el._$('.quick-access__triggers')
    };

    this.identifier = this.dom.$tabsContainer.dataset.identifier;
    this.tabActiveClass = 'quick-access--tab-active';
    if (this.dom.$triggers.length) this.activateFirstTab();
    this.setup();
  }

  addListeners() {
    this.dom.$triggers._on('click', this.handleTriggerClick.bind(this))
  }

  handleTriggerClick() {
    const isActive = this.el.classList.contains(this.tabActiveClass);

    if (window.matchMedia(`(max-width: ${BREAKPOINTS.TABLET_LANDSCAPE - 1}px)`).matches && isActive)
      this.dom.$panels.forEach((el, i) => i === 0 ? el.removeAttribute('aria-hidden') : el.ariaHidden = true);

    this.el.classList.toggle(this.tabActiveClass, !isActive);
  }

  activateFirstTab() {
    const tab = this.dom.$triggers[0];
    tab.setAttribute('aria-selected', 'true');
    const controls = tab.getAttribute('aria-controls');
    document.getElementById(controls).removeAttribute('aria-hidden');
  }

  setup() {
    [...this.dom.$triggers, ...this.dom.$panels].forEach(el => {
      el.dataset.identifier = this.identifier;
    });
    this.dom.$triggers.forEach((el, i) => {
      el.dataset.index = i;
      this.dom.$triggersContainer.append(el);
    });

    new Tabs(this.dom.$tabsContainer);
  }
}

export default Module;
